import App from './app'
import './index.css'
export default App;

